import styled from "styled-components";
import { BOTTOM_NAVIGATOR } from "common/constants";
import { hexToRGB } from "@shared/utils/misc.ts";
import Flex from "common/Boxes/Flex.tsx";

export const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: ${BOTTOM_NAVIGATOR}) {
    :hover {
      background-color: ${(p) => hexToRGB(p.theme.colors.primaryBlue, 0.05)};
      color: ${(p) => p.theme.colors.primaryBlue};
      border-radius: 4px;
    }
  }
`;
